import { useTranslation } from 'react-i18next';

import { ROUTES } from 'theSource/app/routes';
import { InternalPage, List, Spacer, HomeLink } from 'theSource/components';

export const LegalDocuments = () => {
  const { t } = useTranslation('pages.legalDocuments');

  return (
    <InternalPage
      testId="legal-docs-page"
      title={t('title')}
      CustomActionComponent={<HomeLink />}
      customActionAlignment="left"
    >
      <Spacer height={6} />
      <List
        items={Object.values(ROUTES.legalDocs)}
        isCombined={false}
        spacing={3}
        valueHolderVariant="body1"
      />
    </InternalPage>
  );
};
